<template>
  <button
    class="btn jour"
    :disabled="!price"
    :class="{
      'the-best': isTheBest,
      selected: this.$store.state.dayReservation == this.fullDate,
      loading: this.loading,
    }"
    @click="setJour()"
  >
    <p class="mois-intitule mb-0" v-if="indexJour">{{ indexJour }}</p>

    <p class="mois-intitule mb-0" v-else></p>

    <transition
      :duration="{ enter: 500, leave: 500 }"
      name="loading"
      v-on:after-enter="afterLeave"
      v-on:before-enter="beforeEnter"
    >
      <div v-if="!$store.state.isLoading" key="price">
        <p class="price mb-0" v-if="price">{{ price + " €" }}</p>
      </div>

      <div v-else key="loader">
        <content-loader></content-loader>
      </div>
    </transition>
  </button>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
  name: "BoutonJour",
  components: {
    ContentLoader,
  },
  props: {
    indexJour: Number,
  },
  data: function() {
    return {
      loading: false,
    };
  },
  computed: {
    isTheBest() {
      return (
        this.$store.getters.getBestPriceByMonth(
          this.$store.getters.activeMonth.month
        ) == this.price
      );
    },

    price() {
      return this.$store.getters.getPriceByDay(this.indexJour);
    },

    fullDate() {
      const activeMonth = this.$store.getters.activeMonth;
      const mm = (activeMonth.month + 1).toString().padStart(2, "0");
      const dd = this.indexJour.toString().padStart(2, "0");
      const fullDate = activeMonth.year + "-" + mm + "-" + dd;
      return fullDate;
    },
  },

  methods: {
    setJour() {
      this.$store.dispatch("setDayReservation", this.fullDate);
      this.$store.dispatch("setPriceReservation", this.price);
    },
    afterLeave() {
      this.loading = false;
    },
    beforeEnter() {
      this.loading = true;
    },
  },
};
</script>
